import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {AvatarComponent} from "./avatar.component";
import {TooltipModule} from 'primeng/tooltip';

@NgModule({
    declarations: [
        AvatarComponent
    ],
    imports: [CommonModule, TooltipModule],
    exports: [
        AvatarComponent
    ]
})
export class AvatarModule { }
